var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("fostplus")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { flat: "" },
              on: {
                click: function ($event) {
                  return _vm.decreaseYear()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "chevron-left" } })],
            1
          ),
          _vm._v(" " + _vm._s(_vm.year) + " "),
          _c(
            "w-link",
            {
              attrs: { flat: "" },
              on: {
                click: function ($event) {
                  return _vm.increaseYear()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "chevron-right" } })],
            1
          ),
        ],
        1
      ),
      _vm.taxes.length == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(
                      " " + _vm._s(_vm.$ct("no-fostplus-taxes-made")) + " "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-list",
        [
          _vm._l(_vm.taxes, function (tax) {
            return _c(
              "w-list-item",
              { key: tax.Code },
              [
                _c("w-list-item-text", [_vm._v(" " + _vm._s(tax.Code) + " ")]),
                _c("w-list-item-taxt", [
                  _vm._v(" €" + _vm._s(tax.Amount) + " "),
                ]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("edit-tax"),
                            expression: "$ct('edit-tax')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editTax(tax)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("delete-tax"),
                            expression: "$ct('delete-tax')",
                          },
                        ],
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.deleteTax(tax)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.addItem()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [
                _vm._v(_vm._s(_vm.$ct("create-new-fostplus-item"))),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _vm.toEditItem
        ? _c("app-product-taxes-edit-fostplus-edit-item", {
            attrs: { year: _vm.year, item: _vm.toEditItem },
            on: {
              refresh: function ($event) {
                return _vm.fetchTaxes()
              },
              close: function ($event) {
                _vm.toEditItem = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }